import { VerificationHomeQueryResults } from '../useVerificationQuery/types';
import { ContextSpecificStepStatus } from './types';

const getBeneficiaryPersonalStatus = (
  data: VerificationHomeQueryResults,
  isPrimaryApplicant: boolean,
): ContextSpecificStepStatus => {
  if (isPrimaryApplicant) {
    // Therefore the user would not be expected to complete this step.
    return 'not-shown';
  }
  if (data.viewer.profile === null) {
    throw new Error('The user profile should be available');
  }
  const {
    hasForeignFiscalResidence,
    incomeRange,
    isSpecifiedUSPerson,
    personalAssets,
  } = data.viewer.profile;
  if (
    // If either of these are true or unset, they cannot continue to submit the application
    hasForeignFiscalResidence !== false ||
    isSpecifiedUSPerson !== false ||
    [
      // Both these must be set to continue
      incomeRange,
      personalAssets,
    ].includes('')
  ) {
    // Therefore the profile has not yet been completed
    return 'waiting';
  }
  return 'complete';
};

export default getBeneficiaryPersonalStatus;
